import { render, staticRenderFns } from "./AskInfo.vue?vue&type=template&id=3a43fb4a&scoped=true&"
import script from "./AskInfo.vue?vue&type=script&lang=ts&"
export * from "./AskInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AskInfo.vue?vue&type=style&index=0&id=3a43fb4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43fb4a",
  null
  
)

export default component.exports